import { Node } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { blockquote } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/blockquote.js';
import { wrappingInputRule } from '../../../../node_modules/prosemirror-inputrules/dist/index.es.js';
import { toggleWrap } from '../../../../node_modules/tiptap-commands/dist/commands.esm.js';
import __vue_component__ from '../renderers/Blockquote.vue.js';

/* eslint-disable */
class Blockqoute extends Node {
  get name() {
    return 'blockquote';
  }

  get schema() {
    return blockquote;
  }

  commands({
    type,
    schema
  }) {
    return () => toggleWrap(type, schema.nodes.paragraph);
  }

  keys({
    type
  }) {
    return {
      'Ctrl->': toggleWrap(type)
    };
  }

  inputRules({
    type
  }) {
    return [wrappingInputRule(/^\s*>\s$/, type)];
  }

  get view() {
    return __vue_component__;
  }

}

export default Blockqoute;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/nodes/Blockqoute.js